import { useState } from "react";
import { useSession } from "../utils/SessionContext";
import api from "../api/api";
import unixTimestamp from "../utils/unixTimestamp";

const useSaveEmail = () => {
  const { session_id, vendorUrl, product_id } = useSession();
  const [status, setStatus] = useState(null);
  const [error, setError] = useState(null);

  const saveEmail = async (email) => {
    const url = `/save_email`;
    try {
      const res = await api.post(url, null, {
        params: {
          session_id,
          vendor_url: vendorUrl,
          product_id,
          email,
          timestamp: unixTimestamp(),
        },
      });
      setStatus(res.data.status);
    } catch (err) {
      setError(err.response ? err.response.data : { message: err.message });
    }
  };

  return { status, error, saveEmail, setStatus };
};

export default useSaveEmail;
